import React, { useEffect, useState } from "react";
import styles from "../topology.module.scss";
import { Form, Select, Button, Row, Col, Card, Grid } from "antd";
import { useAppSelector } from "store/hook";
import { useTranslation } from "react-i18next";
import { useDeviceStatus } from "Components/Dashboard/queries";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useMDCollapse } from "Utility/hooks/mdCollapse";

const { Option } = Select;

const healthoptions = ["up", "critical", "warning", "offline"];
const strengthoptions = ["excellent", "good", "fair", "poor", "na"];

interface routerSateFilterProps {
  setDeviceStatus: (arg: any) => void;
  uploading: boolean;
  Restore: any;
}

const RouterStateFilterC = React.memo(({ setDeviceStatus, uploading, Restore }: routerSateFilterProps) => {
  const { stateCid, loginCid, level } = useAppSelector((state) => state.global);

  const { isCollapse, setIsCollapse, isMD } = useMDCollapse();
  const [form] = Form.useForm();
  const [filterCondition, setFilterCondition] = useState({});
  const { t } = useTranslation();
  const { isLoading: deviceStatusLoading, data: deviceStatus } = useDeviceStatus(level, stateCid, loginCid);
  const loading = deviceStatusLoading || uploading;

  //在有做篩選的情況下, refresh後要能維持篩選結果
  useEffect(() => {
    form.setFieldsValue(filterCondition);
    form.submit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Restore]);

  const onFinish = (values: any) => {
    //每次進行篩選 都記錄篩選條件
    setFilterCondition(values);

    //從restore當中 篩選出符合條件的結果
    let newRestoreData = Restore;
    newRestoreData = newRestoreData?.filter((item: any) => {
      //篩選出該device 有符合條件的group name
      const groupMatchCondition = item.Group.filter(
        (groupName: string) =>
          // values.groups.includes(groupName)
          values?.groups?.indexOf(groupName) > -1
      );

      const matchChecker = (condition: any, item: any, extraItem = false) => {
        if (condition.length) {
          return condition.includes(item) || condition.includes(extraItem);
        } else {
          return true;
        }
      };

      const isMatch =
        matchChecker(values.device, item.Device) &&
        matchChecker(values.model, item.Model) &&
        matchChecker(values.health, item.Health) &&
        matchChecker(values.strength, item.Strength) &&
        matchChecker(values.cities, item.Location) &&
        matchChecker(values.groups, groupMatchCondition[0]) &&
        matchChecker(values.descriptions, item.Description);

      // (values.groups.length ? groupMatchCondition.length : true)

      return isMatch;
    });
    // getNewOptions(newRestoreData)
    setDeviceStatus(newRestoreData);
  };

  // const ObjToArray = (obj) => {
  //   return Array.from(obj)
  // }

  // const getNewOptions = (TableData) => {
  //   if(!TableData){
  //     return
  //   }
  //   let newDeviceOptions = new Set()
  //   let newModelOptions = new Set()
  //   let newHealthOptions = new Set()
  //   let newStrengthOptions = new Set()
  //   let newGroupOptions = new Set()
  //   let newLocationOptions = new Set()
  //   TableData.forEach((item)=>{
  //     newDeviceOptions.add(item.name!==''?item.name:item.id)
  //     newModelOptions.add(item.model)
  //     newHealthOptions.add(item.health)
  //     newStrengthOptions.add(item.strength)
  //     if(item.gid.length){
  //       item.gid.forEach((group)=>newGroupOptions.add(group))
  //     }
  //     if(item.city){
  //       newLocationOptions.add(item.city)
  //     }
  //   })

  //   const Options = {device:ObjToArray(newDeviceOptions), model:ObjToArray(newModelOptions), health:ObjToArray(newHealthOptions), strength: ObjToArray(newStrengthOptions), group:ObjToArray(newGroupOptions), location:ObjToArray(newLocationOptions)}
  //   setOptions(Options)
  // }

  function titleCase(str: string) {
    let newStr = str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();
    if (newStr === "Up") {
      newStr = "Good";
    }
    // if (newStr === "Poor") {
    //   newStr = "Poor/NA";
    // }
    return newStr;
  }

  // function tagRender({ label, value, closable, disabled, onClose }: { label: string, value: any, closable: boolean, disabled: boolean, onClose:any }) {
  //   return (
  //     <Tag
  //       color={ColorSorter(label)}
  //       closable={closable}
  //       onClose={onClose}
  //       style={{ marginRight: 3 }}
  //     >
  //       {label}
  //     </Tag>
  //   );
  // }

  return (
    <Card
      title={isMD ? "Filter" : null}
      extra={
        isMD && (
          <Button
            type="text"
            icon={!isCollapse ? <UpOutlined /> : <DownOutlined />}
            onClick={() => setIsCollapse((prev) => !prev)}
          ></Button>
        )
      }
      bodyStyle={isCollapse ? { display: "none" } : {}}
    >
      <Form onFinish={onFinish} form={form} layout="vertical">
        <div className="formwrap">
          <Row gutter={24}>
            <Col xs={24} sm={24} md={12} lg={9} xl={9} xxl={4} className={styles.colum}>
              <Form.Item name="device" label={t("ISMS.Device")} initialValue={[]}>
                <Select
                  loading={loading}
                  disabled={loading}
                  // maxTagCount={1}
                  maxTagCount={"responsive"}
                  mode="multiple"
                  // mode="tags"
                  allowClear
                  autoClearSearchValue={false}
                  placeholder={t("ISMS.Search")}
                  // tagRender={tagRender}
                  onChange={() => form.submit()}
                >
                  {Restore?.map((item: any, index: number) => {
                    return (
                      <Option key={index} value={item.Device}>
                        {item.Device}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={10} lg={5} xl={5} xxl={3} className={styles.colum}>
              <Form.Item initialValue={[]} name="model" label={t("ISMS.Model")} className={styles.FilterModel}>
                <Select
                  loading={loading}
                  disabled={loading}
                  mode="multiple"
                  // maxTagCount={1}
                  maxTagCount={"responsive"}
                  allowClear
                  autoClearSearchValue={false}
                  placeholder={t("ISMS.Search")}
                  // tagRender={tagRender}
                  onChange={() => form.submit()}
                >
                  {deviceStatus?.response?.models?.map((item: any, index: number) => (
                    <Option key={index} value={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={10} lg={5} xl={5} xxl={3} className={styles.colum}>
              <Form.Item initialValue={[]} name="health" label={t("ISMS.Health")} className={styles.FilterHealth}>
                <Select
                  loading={loading}
                  disabled={loading}
                  // maxTagCount={1}
                  maxTagCount={"responsive"}
                  mode="multiple"
                  placeholder={t("ISMS.Search")}
                  allowClear
                  autoClearSearchValue={false} // tagRender={tagRender}
                  // style={{ width: "100%" }}
                  // options={healthoptions}
                  onChange={() => form.submit()}
                >
                  {healthoptions?.map((item, index) => (
                    <Option key={index} value={item}>
                      {titleCase(item)}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={10} lg={5} xl={5} xxl={3} className={styles.colum}>
              <Form.Item initialValue={[]} name="strength" label={t("ISMS.Signal")} className={styles.FilterStrength}>
                <Select
                  loading={loading}
                  disabled={loading}
                  mode="multiple"
                  placeholder={t("ISMS.Search")}
                  allowClear
                  autoClearSearchValue={false}
                  // maxTagCount={1}
                  maxTagCount={"responsive"}
                  // tagRender={tagRender}
                  // style={{ width: "100%" }}
                  // options={strengthoptions}
                  onChange={() => form.submit()}
                >
                  {strengthoptions?.map((item, index) => (
                    <Option key={index} value={item}>
                      {titleCase(item)}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={10} lg={5} xl={5} xxl={3} className={styles.colum}>
              <Form.Item name="groups" label={t("ISMS.Group")} initialValue={[]}>
                <Select
                  loading={loading}
                  disabled={loading}
                  mode="multiple"
                  placeholder={t("ISMS.Search")}
                  allowClear
                  autoClearSearchValue={false}
                  // maxTagCount={1}
                  maxTagCount={"responsive"}
                  // tagRender={tagRender}
                  onChange={() => form.submit()}
                >
                  {deviceStatus?.response?.groups?.map((item: any, index: number) => {
                    return (
                      <Option key={index} value={item}>
                        {item}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={10} lg={5} xl={5} xxl={3} className={styles.colum}>
              <Form.Item name="cities" label={t("ISMS.Location")} initialValue={[]}>
                <Select
                  loading={loading}
                  disabled={loading}
                  mode="multiple"
                  placeholder={t("ISMS.Search")}
                  allowClear
                  autoClearSearchValue={false}
                  // maxTagCount={1}
                  maxTagCount={"responsive"}
                  // tagRender={tagRender}
                  onChange={() => form.submit()}
                >
                  {deviceStatus?.response?.locations?.map((item: any, index: number) => {
                    return (
                      <Option key={index} value={item}>
                        {item}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={10} lg={5} xl={5} xxl={3} className={styles.colum}>
              <Form.Item name="descriptions" label={t("ISMS.Description")} initialValue={[]}>
                <Select
                  loading={loading}
                  disabled={loading}
                  mode="multiple"
                  placeholder={t("ISMS.Search")}
                  allowClear
                  autoClearSearchValue={false}
                  // maxTagCount={1}
                  maxTagCount={"responsive"}
                  // tagRender={tagRender}
                  onChange={() => form.submit()}
                >
                  {deviceStatus?.response?.descriptions?.map((item: any, index: number) => {
                    return (
                      <Option key={index} value={item}>
                        {item}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={4} md={3} lg={3} xl={3} xxl={2} className={styles.colum}>
              <Form.Item>
                <Button
                  type={"primary"}
                  loading={loading}
                  disabled={loading}
                  onClick={() => {
                    setDeviceStatus(Restore);
                    form.setFieldsValue({
                      device: [],
                      model: [],
                      health: [],
                      strength: [],
                      groups: [],
                      cities: [],
                      descriptions: [],
                    });
                    setFilterCondition({});
                    // setOptions(restoreOptions)
                  }}
                >
                  {t("ISMS.Clear")}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </div>
      </Form>
    </Card>
  );
});

export default RouterStateFilterC;
